<div class="modal-overlay" *ngIf="isOpen" (click)="closeModal()">
  <div class="modal-container" (click)="$event.stopPropagation()">
    <div class="modal-header">
      <h2 class="modal-title">{{ title }}</h2>
      <button class="modal-close" (click)="closeModal()">&times;</button>
    </div>
    <div class="modal-body">
      <p class="modal-message">{{ message }}</p>
    </div>
    <div class="modal-footer">
      <button 
        *ngIf="showCancelButton" 
        class="modal-button cancel-button" 
        (click)="onCancel()">
        {{ cancelButtonText }}
      </button>
      <button 
        class="modal-button confirm-button" 
        (click)="onConfirm()">
        {{ confirmButtonText }}
      </button>
    </div>
  </div>
</div>
